<template>
  <div>
    <div v-if="visibleFilter !== null" class="filter-overlay" @click="hideFilter"></div>
    <div class="container-fluid d-block d-lg-none">
      <button class="btn btn-grey open-filters" @click="filtersOpen = !filtersOpen">Filters</button>
    </div>

    <div class="filters" :class="{ open: filtersOpen }">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-lg-10">

            <div v-if="ready" class="filter-wrapper">
              <checkbox-filter
                  v-if="Object.keys($getTypes).length > 1"
                  label="Soort woning"
                  name="building_type"
                  description="Wat voor een soort woning zoek je?"
                  v-model="filters.building_type"
                  :options="$getTypes"
                  :open="visibleFilter === 'building_type'"
              />
              <div style="display: inline-block" v-for="(filter, name) in $store.state.apiData.filters" :key="name">
                <checkbox-filter
                    v-if="filter.type === 'equal'"
                    :label="filter.name"
                    :name="name"
                    :description="getDescription(name)"
                    v-model="filters[name]"
                    :options="getList(name)"
                    :open="visibleFilter === name"
                />
                <range-filter
                    v-if="filter.type === 'between'"
                    :label="filter.name"
                    :name="name"
                    :description="getDescription(name)"
                    :unit="getUnit(name)"
                    v-model="filters[name]"
                    :open="visibleFilter === name"
                    :min="getMinMax(name)[0]"
                    :max="getMinMax(name)[1]"
                />
              </div>

            </div>
          </div>
          <div class="col-12 col-lg-2">
            <div class="d-none d-lg-flex justify-content-end delete-filter-wrapper">
              <button @click="resetFilters" class="delete-filter">Filters wissen</button>
            </div>
            <div class="filters__footer d-flex d-lg-none">
              <span @click="resetFilters">Wissen</span>
              <span @click="setFilters">Toepassen</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import RangeFilter from '../filters/RangeFilter'
  import CheckboxFilter from '../filters/CheckboxFilter'


  export default {
    name: 'filters',
    components: {

      RangeFilter,
      CheckboxFilter,
    },
    data() {
      return {
        ready: false,
        visibleFilter: null,
        filtersOpen: false,
        timer: null,
        filters: {},
        defaultFilters: {},
      }
    },
    mounted () {
      if(Object.keys(this.$store.state.filters).length){
        this.filters = this.$store.state.filters
//        console.log(this.filters)
      }
      this.initFilters()
      this.ready = true
    },
    methods:{
      initFilters(){

        let reset = true
        if(Object.keys(this.filters).length){
          reset = false
        }

        Object.entries(this.$store.state.apiData.filters).forEach((filter) => {
          let value = []
          let filterName = filter[0]
          if(filter[1].type === 'between'){
            value = this.getMinMax(filterName)
          }
          if(reset) {
            this.$set(this.filters, filterName, value)
          }
          this.$set(this.defaultFilters, filterName, value)
        })
      },
      resetFilters () {

        this.filters = this.$clone(this.defaultFilters)
      },
      setFilters () {
        this.$store.commit('setFilters', this.$clone(this.filters))
      },
      getMinMax (name) {
        let max = 0
        let min = 9999999999
        name = name.split('|')
        this.$store.state.apiData.objects.forEach((object) => {
          let value = object
          name.forEach((row) => {
            value = value[row]
          })
          if(value > max){
            max = value
          }
          if(value < min){
            min = value
          }
        })
        return [min, max]
      },
      getList (name) {
        let list = {}
        name = name.split('|')
        this.$store.state.apiData.objects.forEach((object) => {
          let value = object
          name.forEach((row) => {
            value = value[row]
          })
          if(!list[value]){
            if(value !== null) {
              list[value] = value
            }
          }
        })
        return list
      },
      getDescription(name){
        let descriptions = {
          'price_value': 'Kies hier de gewenste prijsklasse in €',
          'characteristics|surface': 'Kies hier het gewenste oppervlak in m²',
          'characteristics|sleeping_rooms': 'Aantal slaapkamers'
        }
        if(descriptions[name]){
          return descriptions[name]
        }
        return ''
      },
      getUnit(name){
        let units = {
          'price_value': '€',
          'characteristics|surface': 'm²'
        }
        if(units[name]){
          return units[name]
        }
        return ''
      },
      clearFilter () {
        // does nothing
      },
      hideFilter () {
        document.body.classList.remove('drop-down-open')
        this.visibleFilter = null
      },
      showFilter (name) {
        document.body.classList.add('drop-down-open')
        this.visibleFilter = name
      },
    },
  }
</script>

<style>
  .filters {
    position: relative;
    z-index:100;
    background-color: white;
    position: fixed;
    width: 100%;
  }
  .delete-filter-wrapper {
    height: 48px;
    align-items: center;
  }

  .filter-overlay {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 99;
  }

  .delete-filter {
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    font-size: 13px;
    font-weight: 500;
    color: #9B9B9B;
  }
</style>
